import { OpportunityQueryKey } from "configs/opportunity.config";
import AppLayout from "layouts/appLayout/AppLayout";
import { useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { Breadcrumb, Button, Link } from "stories";
import { OpportunityController } from "../../../../../services/opportunity/controller";
import { breadcrumbItems } from "../../../contstants";
import OpportunityCard from "../../index/elements/opportunityCard/OpportunityCard";
import classes from "./ProposedProject.module.scss";
import { ProposedProjectFields } from "./ProposedProjectFields";

const opportunityController = OpportunityController();

const ProposedProject = () => {
  const params = useParams();
  const queryClient = useQueryClient();
  const queryKey = [OpportunityQueryKey, { id: params.id }];
  const { isLoading, data: opportunity } = useQuery({
    queryKey,
    queryFn: opportunityController.getById.bind(null, params.id),
  });

  const refetch = useCallback(() => {
    queryClient.invalidateQueries(queryKey);
  }, [queryClient]); //eslint-disable-line

  return (
    <AppLayout
      title={"Complete full details about the opportunity"}
      hideSidebar
      backButton
    >
      <Helmet>
        <title>Proposed Project | Fundever</title>
      </Helmet>
      <Breadcrumb items={breadcrumbItems} selectedId={1} />
      <div className={classes["main-wrapper"]}>
        <div className={"mb-3"}>
          <OpportunityCard
            readOnly
            loading={isLoading}
            data={{ id: params.id, ...opportunity }}
          />
          {opportunity && (
            <ProposedProjectFields
              opportunity={opportunity}
              onUpdate={refetch}
            />
          )}
          <Row className={"mt-4"}>
            <Col xs={7} />
            <Col>{/* <Button outline label={"Publish Now"} /> */}</Col>
            <Col>
              <Link to={"../financial-breakdown"}>
                <Button label={"Next Step"} />
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    </AppLayout>
  );
};

export default ProposedProject;
